import { reactive, ref, nextTick } from "vue";
import piniaStore from "@/piniaStore";
export default function () {
  const proxy = this;
  const { mainStore, dataStore } = piniaStore;
  const useMainStore = mainStore();
  const useDataStore = dataStore();

  // ref
  const formRef = ref();

  // 参数
  const defaultClientInfo = () => ({
    contactWay: "",
    demandDescribe: "",
    named: "",
  });
  const clientForm = reactive(defaultClientInfo());
  let lastRecordedClientInfo = defaultClientInfo();
  const clientFormRules = {
    contactWay: [
    ],
  };

  // 提交需求
  // 回放恢复输入只更新展示，不可再次提交真实需求；仍要释放调用方的按钮加载状态。
  const formSubmit = async (closeLoading) => {
    if (proxy.$route.query.ip) {
      if (typeof closeLoading === "function") closeLoading();
      return;
    }
    const call = async (closeLoading) => {
      const testRes = await proxy.$testForm(closeLoading, formRef.value);
      if (!testRes) {
        return;
      }

      // 获取差异值
      const diffData = proxy.$getDataUpdateAfter(
        defaultClientInfo(),
        clientForm,
      );
      if (!Object.keys(diffData).length) {
        proxy.$message.warning("请先填写完整的需求资料");
        closeLoading();
        return;
      }

      try {
        await proxy.$storeDispatch("fetchAddClientDemand", clientForm);
        proxy.$message.success("提交成功");
        proxy.$updateParams(clientForm, defaultClientInfo());
        lastRecordedClientInfo = defaultClientInfo();
        closeLoading();
      } catch (error) {
        closeLoading();
      }
    };

    // 记录鼠标操作
    useDataStore.setGlobalClickRecord(function () {
      document.getElementById("form-submit").click();
    });
    call(closeLoading);
  };

  // 输入框失焦时，整体表单有变化才添加客户需求词条
  // 与需求提交使用相同的回放保护，防止恢复表单值后失焦再次生成客户词条。
  const addClientDemandEntry = async () => {
    if (proxy.$route.query.ip) return;
    await nextTick();
    const formData = { ...clientForm };
    if (
      Object.keys(formData).every(
        (key) => formData[key] === lastRecordedClientInfo[key],
      )
    ) {
      return;
    }

    // 请求前保存快照以抑制重复失焦；失败时仅回退本次快照，不能覆盖后续输入。
    const previousClientInfo = lastRecordedClientInfo;
    lastRecordedClientInfo = formData;
    try {
      const groupNo = useMainStore.getSubmitGroupNo();
      await proxy.$storeDispatch("fetchAddClientDemandEntry", {
        ...formData,
        groupNo,
      });
    } catch (error) {
      // 记录失败时允许下次失焦重试，避免覆盖后续的新快照
      if (lastRecordedClientInfo === formData) {
        lastRecordedClientInfo = previousClientInfo;
      }
    }
  };

  return {
    formRef,
    clientForm,
    clientFormRules,
    formSubmit,
    addClientDemandEntry,
  };
}
